import React, { useMemo } from 'react';

import type { Message } from '../../@types/chat';
import Format from '../Format';
import { sanitizeClassName } from '../../utils/sanitize';
import { formatDate } from '../../utils/format-date';

type MessageProps = {
    message: Message;
};

export default function Message(props: MessageProps) {
    const senderClass = useMemo(() => {
        return sanitizeClassName(props.message.sender);
    }, [props.message.sender]);

    const isBot = props.message.sender === 'BOT';

    return <>
        <div className={`chat--popup--message chat--popup--message--type--${senderClass}`}>
            <Format className="chat--popup--message--text govuk-body-s" markdown={isBot}>{props.message.message}</Format>
            <div className="chat--popup--message--date govuk-body-s">{formatDate(props.message.date)}</div>
        </div>
    </>;
}
